import { useState } from "react";
import { Truck, FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { downloadStatement } from "../lib/api";
import { carrierStats, money } from "../lib/payments";

export const CarrierStats = ({ payments }) => {
  const rows = carrierStats(payments);
  const [busy, setBusy] = useState("");
  const download = async (name) => {
    setBusy(name);
    try {
      await downloadStatement(name);
    } catch {
      toast.error("Could not create the statement");
    } finally {
      setBusy("");
    }
  };
  if (!rows.length) return null;
  return (
    <div data-testid="carrier-stats" className="bg-[#13161C] border border-[#262C38] rounded-md">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-[#262C38]">
        <Truck className="h-4 w-4 text-[#F95722]" />
        <span className="font-heading font-bold uppercase tracking-wide text-white">Revenue by carrier</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs sm:text-sm">
          <thead>
            <tr className="font-mono text-[10px] uppercase tracking-widest text-slate-500">
              <th className="px-2 sm:px-3 py-2 text-left">Carrier</th>
              <th className="hidden sm:table-cell px-2 sm:px-3 py-2 text-right">Drivers</th>
              <th className="px-2 sm:px-3 py-2 text-right">Received</th>
              <th className="px-2 sm:px-3 py-2 text-right">Owed</th>
              <th className="px-2 sm:px-3 py-2 text-right">Paid late</th>
              <th className="hidden sm:table-cell px-2 sm:px-3 py-2 text-right">Avg late</th>
              <th className="px-2 sm:px-3 py-2 text-right">PDF</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.name} data-testid={`carrier-row-${i}`} className="border-t border-[#262C38]">
                <td className="px-2 sm:px-3 py-2.5 text-white">{r.name}</td>
                <td className="hidden sm:table-cell px-2 sm:px-3 py-2.5 text-right font-mono text-slate-300">{r.drivers}</td>
                <td data-testid={`carrier-received-${i}`} className="px-2 sm:px-3 py-2.5 text-right font-mono text-emerald-300">{money(r.received)}</td>
                <td data-testid={`carrier-owed-${i}`} className="px-2 sm:px-3 py-2.5 text-right font-mono text-slate-300">
                  {money(r.owed)}{r.overdueNow ? <span className="block text-[10px] text-red-300">{r.overdueNow} overdue now</span> : null}
                </td>
                <td data-testid={`carrier-late-rate-${i}`} className={`px-2 sm:px-3 py-2.5 text-right font-mono ${r.lateRate > 0.5 ? "text-red-300" : r.lateRate > 0 ? "text-amber-300" : "text-slate-300"}`}>
                  {r.paidHalves ? `${r.paidLate}/${r.paidHalves}` : "—"}
                </td>
                <td data-testid={`carrier-avg-late-${i}`} className="hidden sm:table-cell px-2 sm:px-3 py-2.5 text-right font-mono text-slate-300">
                  {r.paidLate ? `${r.avgLate.toFixed(1)}d` : "—"}
                </td>
                <td className="px-2 sm:px-3 py-2.5 text-right">
                  <button data-testid={`carrier-statement-btn-${i}`} onClick={() => download(r.name)} disabled={!!busy} title="Download statement PDF"
                    className="inline-flex items-center gap-1 text-[11px] font-bold px-2 py-1 rounded border border-[#384152] text-slate-200 hover:border-[#F95722] disabled:opacity-50">
                    {busy === r.name ? <Loader2 className="h-3 w-3 animate-spin" /> : <FileDown className="h-3 w-3" />}
                    <span className="hidden sm:inline">Statement</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="px-4 py-2 text-[11px] font-mono text-slate-500 border-t border-[#262C38]">
        Sorted by money received. Paid late = halves paid after the due date / halves paid. Avg late = average working days late on those late payments.
      </p>
    </div>
  );
};
